import { Component, ViewChild, signal, OnInit, OnDestroy, ChangeDetectionStrategy, DestroyRef } from '@angular/core';
import { MediaMatcher } from '@angular/cdk/layout';
import { MatSidenav, MatSidenavModule } from '@angular/material/sidenav';
import { AppState } from 'src/app/+state/applications';
import { Store } from '@ngrx/store';
import { toggleMenuSidebar } from 'src/app/+state/app/app.actions';
import { appStatus } from 'src/app/+state/app/app.selectors';
import { takeUntilDestroyed, toSignal } from '@angular/core/rxjs-interop';

import { ActivatedRoute, NavigationEnd, Router, RouterModule } from '@angular/router';
import { MatDividerModule } from '@angular/material/divider';
import { NavbarComponent } from '../../shared/navbar/navbar.component';
import { SidenavContentComponent } from '../sidenav-content/sidenav-content.component';
import { FooterComponent } from '../footer/footer.component';
import { filter } from 'rxjs/operators';

@Component({
    selector: 'app-sidenav',
    templateUrl: './sidenav.component.html',
    styleUrls: ['./sidenav.component.scss'],
    standalone: true,
    imports: [
    RouterModule,
    MatSidenavModule,
    MatDividerModule,
    NavbarComponent,
    SidenavContentComponent,
    FooterComponent
],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SidenavComponent implements OnInit, OnDestroy {
  @ViewChild(MatSidenav) sidenav: MatSidenav;
  
  private mobileQuery: MediaQueryList;
  private toggling = false;
  private mediaQueryListener = (e: MediaQueryListEvent) => {
    this.isMobile.set(e.matches);
  };

  isMobile = signal(false);
  showSidebar = signal(true);
  appStatus = toSignal(this.store.select(appStatus));

  constructor(
    private media: MediaMatcher,
    private store: Store<AppState>,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private destroyRef: DestroyRef
  ) {
    this.mobileQuery = this.media.matchMedia('(max-width: 800px)');
    this.isMobile.set(this.mobileQuery.matches);
    this.updateSidebarVisibility();
  }

  ngOnInit() {
    this.mobileQuery.addEventListener('change', this.mediaQueryListener);
    this.router.events.pipe(
      filter(e => e instanceof NavigationEnd),
      takeUntilDestroyed(this.destroyRef)
    ).subscribe(() => this.updateSidebarVisibility());
  }

  ngOnDestroy() {
    this.mobileQuery.removeEventListener('change', this.mediaQueryListener);
  }

  navigationClick() {
    if (this.isMobile()) {
      this.toggle();
    }
  }

  toggle() {
    if (!this.showSidebar()) return;
    if (this.toggling) return;
    this.toggling = true;
    
    this.sidenav.toggle().then(() => {
      this.store.dispatch(toggleMenuSidebar({ 
        action: this.sidenav.opened ? 'open' : 'close' 
      }));
      this.toggling = false;
    }).catch(() => {
      this.toggling = false;
    });
  }

  private updateSidebarVisibility() {
    let route = this.activatedRoute;

    while (route.firstChild) {
      route = route.firstChild;
    }

    this.showSidebar.set(route.snapshot.data['showSidebar'] !== false);
  }

}
